import { SET_BANNER_MESSAGES_SEEN } from "./../../actions/actionTypes/bannerMessage";

interface InitialState {
  seenIds: any[];
}
const initialState: InitialState = {
  seenIds: [],
};

export function bannerMessage(state = initialState, action: any) {
  switch (action.type) {
    case SET_BANNER_MESSAGES_SEEN:
      const { ids } = action;
      return {
        ...state,
        seenIds: JSON.parse(ids),
      };
    default:
      return state;
  }
}
